import type { ReactNode } from "react";

import { QcIncidentMessage } from "@/components/qc/QcIncidentMessage";

/** Renders `**bold**` segments in configuration submit failure copy from the API. */
export function renderConfigurationSubmitFailureMessage(message: string): ReactNode {
  const parts = message.split(/\*\*(.+?)\*\*/g);
  if (parts.length === 1) {
    return (
      <span className="whitespace-pre-wrap">
        <QcIncidentMessage message={message} />
      </span>
    );
  }
  return (
    <span className="whitespace-pre-wrap">
      {parts.map((part, index) =>
        index % 2 === 1 ? (
          <strong key={`configuration-submit-failure-bold-${index}`}>
            <QcIncidentMessage message={part} />
          </strong>
        ) : (
          <QcIncidentMessage key={`configuration-submit-failure-text-${index}`} message={part} />
        ),
      )}
    </span>
  );
}
